import React, { Component } from 'react';

class TableRow2 extends Component {
  render() {
    return (
        <tr>
          <td style={{backgroundColor:this.props.obj.vinculado=="S" ? '#e8eaa1' :''}} >
          <center> {this.props.obj.ap_paterno}</center>
          </td>
          <td  >
          <center> {this.props.obj.ap_materno}</center>
          </td>
          <td  >
          <center> {this.props.obj.nombre}</center>
          </td>
          <td >
          <center>{this.props.obj.fecha_nac.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1')}</center>
          </td>
          <td >
          <center>{this.props.obj.estado_civil}</center>
          </td>
          <td>
          <center> {this.props.obj.ocupacion}</center>
          </td>

          <td>
          <center>{this.props.obj.fecha_cita.substring(0,10).replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1')} {this.props.obj.fecha_cita.substring(11,19)}</center>
          </td>
        
          
        </tr>
    );
  }
}

export default TableRow2;